<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <div class="wrapper">
        <div class="cost" >
          <p><font-awesome-icon class="check-icon" :icon="['fas', 'check']"/>{{ $t('thank-you.email-was-sent')}}</p>

          <div class="report-title">{{ $t('thank-you.title')}}</div>
          <div>
            {{ $t('thank-you.body-1')}}
          </div>
          <h3>
<!--            {{ $t('thank-you.body-2')}}-->
<!--            <a v-if="this.$i18n.locale === 'en'" href="mailto: smarthome@1home.io" style="color: #008996 !important;">smarthome@1home.io</a>-->
          </h3>
        </div>
        <CalendlyCall></CalendlyCall>
      </div>
    </div>
  </div>
</template>

<script>
import CalendlyCall from "../components/CalendlyCall";

export default {
  name: "Finish",
  components: { CalendlyCall },
  methods: {
    redirectToHome() {
      window.location.href = "https://www.1home.io/360/beratung/";
    }
  },
  mounted() {
    this.redirectToHome();
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.check-icon {
  color: $color-primary;
  padding-right: 5px;
}

.wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}
.cost {
  flex-grow: 1;
  flex-basis: 0;
  text-align: left;
  justify-content: center;
  margin-right: 40px;
}
.work-with-us {
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  padding: 20px 0 20px 0;
}

.report-title {
  margin-top: 50px;
  margin-bottom: 20px;
  font-size: 38px;
  font-weight: bold;
  font-family: $font-secondary;
}

@media only screen and (max-width: 768px) {
  .wrapper {
    display: unset;
  }
  .cost {
    text-align: center;
    margin-right: 0;
    margin-bottom: 60px;
  }
  .work-with-us img {
    max-width: 100%;
  }
}
</style>
